/**
 * @flow
 */

/* eslint-disable */

'use strict';

/*::
import type {ConcreteFragment} from 'relay-runtime';
export type SbSharedRefineMenuFilterPeriod_searchBrowse = {| |};
*/


const fragment /*: ConcreteFragment*/ = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "SbSharedRefineMenuFilterPeriod_searchBrowse",
  "selections": [
    {
      "kind": "FragmentSpread",
      "name": "SbSharedRefineMenuMultiSelectList_searchBrowse",
      "args": null
    }
  ],
  "type": "SearchBrowseQueryConnection"
};

module.exports = fragment;
